export enum WeekDay {
	Sunday = 1,
	Monday = 2,
	Tuesday = 3,
	Wednesday = 4,
	Thursday = 5,
	Friday = 6,
	Saturday = 7,
}

export enum OperationIds {
	Matches = 0,
	Equals = 5,
	Contains = 1,
	StartsWith = 3,
	EndsWith = 4,
	ContainsKey = 6,
	ContainsValue = 7,
	GreaterThan = 8,
	LessThan = 9,
	IsEmpty = 10,
	EqualsIgnoreWhitespace = 11,
}

export enum Operation {
	Matches = 'matches',
	Contains = 'contains',
	StartsWith = 'starts-with',
	EndsWith = 'ends-with',
	Equals = 'equals',
	ContainsKey = 'contains-key',
	ContainsValue = 'contains-value',
	GreaterThan = 'greater-than',
	LessThan = 'less-than',
	IsEmpty = 'is-empty',
	EqualsIgnoreWhitespace = 'equals-ignore-whitespace',
}

export interface Condition {
	order?: number;
	customKey?: string;
	field: string;
	expectedValue: string;
	not: boolean;
	operation: OperationIds;
	fieldFreeForm?: boolean;
}

export enum MatchConditionType {
	'match-all' = 0,
	'match-any-condition' = 1,
	'match-all-conditions' = 2,
}

export interface TimeRestriction {
	startHour: number;
	startMinute: number;
	endHour: number;
	endMinute: number;
	startDay?: WeekDay;
	endDay?: WeekDay;
}
